(function($, ns) {
    'use strict';

    var cfg = {
        cache: {
            searchButton: '.btn-search',
            searchInput: 'input',
            languageToggler: '.dealer-language-toggler',
            languageTogglerContent: '.dealer-language-content'
        },
        classes: {
            invisible: 'invisible',
            opened: 'opened'
        },
        data: {
            url: 'url',
            productType: 'product-type'
        },
        attributes: {},
        events: {
            click: 'click',
            keydown: 'keydown'
        },
        options: {}
    };

    ns.DealerSearchToggle = function(container) {
        this.container = container;
        this.settings = cfg;
        this.init();
    };

    ns.DealerSearchToggle.prototype = {
        init: function() {
            this.cacheItems();
            if (this.url && this.url.length) {
                this.bindEvents();
                this.activate();
            }
        },
        cacheItems: function() {
            var settings = this.settings,
                cache = settings.cache,
                data = settings.data;

            this.searchButton = this.container.find(cache.searchButton);
            this.searchInput = this.container.find(cache.searchInput);
            this.languageToggler = this.container.find(cache.languageToggler);
            this.languageTogglerContent = this.container.find(cache.languageTogglerContent);

            this.url = this.container.data(data.url);
            this.productType = this.container.data(data.productType);
        },
        bindEvents: function() {
            var settings = this.settings,
                events = settings.events;

            this.searchInput.on(events.keydown, e => {
                if (e.keyCode == 13) {
                    this.searchButton.trigger(events.click);
                }
            });

            this.searchButton.on(events.click, () => {
                let zip = this.searchInput.val();
                
                let url = this.url;

                if (zip && zip.length) {
                    if (url.indexOf('?') > -1) {
                        url += '&';
                    } else {
                        url += '?';
                    }

                    url += 'zip=' + zip;
                }

                if (this.productType && this.productType.length) {
                    url += '&dealerType=' + this.productType;
                }

                window.location.href = url;

                return false;
            });

            this.languageToggler.on(events.click, this.handleLangaueTogglerClick.bind(this));
        },
        activate: function() {
            // nothing to do here...
        },

        handleLangaueTogglerClick: function(e) {
            const {classes} = Object.assign(this.settings)
            $(e.currentTarget).toggleClass(classes.opened);
            this.languageTogglerContent.toggleClass(classes.invisible)
        }
    };

    return ns;
})(window.jQuery, window.Dom || {});
